'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultEmailConfirmation = exports.nonRequiredEmail = exports.defaultEmail = undefined;
var _wavfichacertaFichacertaUtils = require('@bit/wavfichacerta.fichacerta.utils.validators');
var _wavfichacertaFichacertaUtils2 = require('@bit/wavfichacerta.fichacerta.utils.warnings');
var sizes = {
  generalMedium: 'col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6'
};
var defaultEmail = exports.defaultEmail = function defaultEmail() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sizes.generalMedium;
  return {
    name: 'email',
    label: 'E-mail',
    isRequired: true,
    size: size,
    type: 'text',
    validate: _wavfichacertaFichacertaUtils.emailValidation,
    placeholder: 'Digite seu e-mail'
  };
};
var nonRequiredEmail = exports.nonRequiredEmail = function nonRequiredEmail() {
  var emailField = defaultEmail();
  var newEmailField = omit(emailField, ['validate']);
  return Object.assign({}, newEmailField, {
    isRequired: false,
    hasValidation: false,
    warn: _wavfichacertaFichacertaUtils2.warnEmail
  });
};
var defaultEmailConfirmation = exports.defaultEmailConfirmation = function defaultEmailConfirmation() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sizes.generalMedium;
  return {
    name: 'email_confirmation',
    label: 'Confirmar e-mail',
    isRequired: true,
    size: size,
    type: 'text',
    placeholder: 'Confirme seu e-mail',
    validate: _wavfichacertaFichacertaUtils.validateEmailConfirmationField
  };
};